export const KENTRO = {
  // Primário (WhatsApp) — mantemos como número principal
  whatsappNumber: "5511915827716",
  whatsappDisplay: "(11) 91582-7716",
  whatsappUrl: (msg = "Olá, vim pelo site da Kentro e quero solicitar uma demonstração.") =>
    `https://wa.me/5511915827716?text=${encodeURIComponent(msg)}`,
  whatsappComercialUrl:
    "https://api.whatsapp.com/send/?phone=553832208706&text=Ol%C3%A1%21+Vim+pelo+site+da+Kentro+e+quero+saber+mais.&type=phone_number&app_absent=0",
  // Lista oficial de telefones de contato (exibir sempre os três)
  phones: [
    { label: "0800", display: "0800 550 2020", tel: "08005502020", whatsapp: false },
    { label: "WhatsApp", display: "(11) 91582-7716", tel: "5511915827716", whatsapp: true },
    { label: "Comercial", display: "(38) 3220-8706", tel: "553832208706", whatsapp: true },
  ] as ReadonlyArray<{ label: string; display: string; tel: string; whatsapp: boolean }>,
  email: "contato@kentro.com.br",
  address: "Alameda Rio Negro, 503, Sala 2020, Alphaville, Barueri/SP, CEP 06454-000",
  links: {
    blog: "/blog",
    academy: "https://www.academy2.kentro.com.br/",
    status: "https://status.kentro.com.br",
    privacidade: "/privacidade",
    linkedin: "https://www.linkedin.com/company/kentro-sistemas",
    instagram: "https://www.instagram.com/kentrosistemas",
    youtube: "https://www.youtube.com/@kentrosistemas",
    tiktok: "https://www.tiktok.com/@kentrooficial",
  },
} as const;

export const NAV_LINKS: ReadonlyArray<{ label: string; href: string; external?: boolean }> = [
  { label: "Atendimento", href: "/gestao-de-atendimento" },
  { label: "Omnichannel", href: "/omnichannel" },
  { label: "IA", href: "/ia" },
  { label: "Segmentos", href: "/#segmentos" },
  { label: "Academy", href: "https://www.academy2.kentro.com.br/", external: true },
  { label: "Blog", href: "/blog" },
];

export const SEGMENTS = [
  {
    slug: "farmacias",
    name: "Farmácias",
    pain: "Pedidos no WhatsApp, dúvidas de estoque, filas e recompra.",
    benefit: "Organize pedidos, histórico e lembretes de receitas recorrentes.",
  },
  {
    slug: "clinicas",
    name: "Clínicas Médicas e Odontológicas",
    pain: "No-show, agendamento desorganizado, dúvidas de convênio e horários.",
    benefit: "Automatize confirmação, lembretes e pré-triagem.",
  },
  {
    slug: "provedores-de-internet",
    name: "Provedores de Internet",
    pain: "Chamados repetitivos, suporte sobrecarregado e cobrança manual.",
    benefit: "Triagem técnica, segunda via, cobrança e SLA integrados.",
  },
  {
    slug: "escolas-e-faculdades",
    name: "Escolas, Cursos e Faculdades",
    pain: "Captação, matrícula, dúvidas repetitivas e comunicação com pais/alunos.",
    benefit: "Qualifique leads, envie lembretes e organize matrículas.",
  },
  {
    slug: "ecommerce",
    name: "E-commerce e Varejo",
    pain: "Abandono de carrinho, dúvidas de frete, pagamento e troca.",
    benefit: "Recupere vendas e responda rápido em todos os canais.",
  },
  {
    slug: "concessionarias",
    name: "Concessionárias",
    pain: "Leads de alto valor esfriam por demora.",
    benefit: "Qualifique interessados, agende test drives e organize follow-up.",
  },
  {
    slug: "condominios",
    name: "Condomínios",
    pain: "Boletos, ocorrências, reservas e solicitações descentralizadas.",
    benefit: "Automatize dúvidas frequentes e registre solicitações.",
  },
  {
    slug: "autopecas-informatica",
    name: "Lojas de Autopeças e Informática",
    pain: "Orçamentos técnicos, compatibilidade, urgência e pós-venda.",
    benefit: "Classifique pedidos e encaminhe clientes urgentes.",
  },
] as const;
